import React from 'react';

// Collapsible help panel surfaced at the top of each new-module editor
// (calc drills, spot-the-error, med-rec, drug-history). Uses the native
// <details> element so there's no React state for open/closed and the
// browser handles keyboard / accessibility for free.
//
// Pass concrete authoring steps in as children. Keep the content
// scannable: short paragraphs, numbered steps, optional examples block.
const EditorHelpPanel = ({ title = 'How to author this drill', defaultOpen = false, children }) => (
  <details className="card mb-3 editor-help-panel" open={defaultOpen}>
    <summary className="card-body py-2 d-flex align-items-center gap-2 editor-help-panel__summary">
      <i className="bi bi-info-circle text-primary" aria-hidden="true" />
      <strong>{title}</strong>
      <span className="ms-auto small text-muted">click to expand</span>
    </summary>
    <div className="card-body pt-0 editor-help-panel__body">
      {children}
    </div>
  </details>
);

export default EditorHelpPanel;
